import yup from 'utils/yup';

export const initialPaymentValue = {
  number: '' as any,
  card_name: '',
  expiry_month: '' as any,
  expiry_year: '' as any,
  cvc: '' as any,
};

export const paymentFormValidationSchema = yup.object().shape({
  number: yup.string().required(),
  card_name: yup.string().required(),
  expiry_month: yup.string().required(),
  expiry_year: yup.string().required(),
  cvc: yup.number().required(),
});
